module.exports = __webpack_public_path__ + "img/实验室动物使用许可证.png";